import React, { FC } from 'react';
import styles from './search_main_snippet_card.module.scss';
import { Paper } from '../../../../components/paper/Paper';

export const SearchMainSnippetCard: FC<React.HTMLProps<HTMLDivElement>> = (
  props,
) => <Paper level={0} className={styles.paper} {...props} />;
